module.exports = __webpack_public_path__ + "img/38933-009.e73ea404.jpg";